import React from "react";
import SEO from "../components/SEO";
import styled from "styled-components";

const SocieteContainer = styled.div`
  padding: 40px 20px;
  max-width: 800px;
  margin: 0 auto;
  color: #b0b0b0; /* Slightly darker light grey for main text */
  text-align: left;
`;

const PageTitle = styled.h1`
  font-size: 48px;
  color: #13519a; /* Keep this blue for main title */
  margin-bottom: 40px;
  text-align: center;
`;

const SectionTitle = styled.h2`
  font-size: 28px;
  color: #13519a; /* Use the same blue as PageTitle */
  margin-top: 2rem;
  margin-bottom: 1rem;
`;

const PageText = styled.p`
  font-size: 18px;
  line-height: 1.6;
  color: #b0b0b0; /* Slightly darker light grey for main text */
  margin-bottom: 20px;
`;

const ServiceList = styled.ul`
  list-style-type: disc;
  margin-left: 20px;
  margin-bottom: 1rem;
  padding-left: 20px;
  font-size: 18px;
  color: #b0b0b0; /* Slightly darker light grey for list items */

  li {
    margin-bottom: 10px;
  }
`;

const Societe = () => {
  return (
    <SocieteContainer>
      <SEO
        title="Notre Société | ImpactIsol - Expert en calorifugeage en Isère"
        description="Découvrez ImpactIsol, expert en calorifugeage industriel et tertiaire en Isère. Isolation thermique, phonique et traçage électrique."
      />
      <PageTitle>Notre Société</PageTitle>
      <PageText>
        Experts dans le domaine du calorifuge,
        nous avons créé la société IMPACTISOL qui a pour vocation de vous
        accompagner dans l’optimisation de l’efficacité énergétique de vos
        installations industrielles et tertiaires.
      </PageText>

      <SectionTitle>Nos services</SectionTitle>
      <ServiceList>
        <li>
          Isolation thermique de réseaux chauds, vapeur, froids, froids négatifs
          et gaz spéciaux.
        </li>
        <li>Installations hydrauliques et aérauliques.</li>
        <li>Isolation phonique, coupe-feu et anti-vibratille.</li>
        <li>
          Traçage électrique pour la protection contre le gel ou le maintien en
          température.
        </li>
      </ServiceList>

      <SectionTitle>Nos valeurs</SectionTitle>
      <ServiceList>
        <li>
          Engagement envers la qualité des services et des réalisations
          techniques.
        </li>
        <li>
          Sécurité des intervenants et respect des consignes spécifiques sur
          site.
        </li>
        <li>Adaptation de nos recommandations selon vos contraintes budgétaires.</li>
        <li>Réactivité de nos équipes.</li>
      </ServiceList>

      <PageText>
        Notre maîtrise des techniques de pose de tous les types d’isolants,
        associée à notre souci du détail lors de la fabrication et de la pose
        des revêtements de protection, font de nous un partenaire sur lequel
        vous pouvez compter, pour vos chantiers les plus techniques, notamment
        en matière de tôlerie fine.
      </PageText>
      <PageText>
        Nous sommes à votre disposition pour répondre à vos consultations sur
        plans ou sur le terrain, et pour vous aider à évaluer au plus juste vos
        besoins dès la réception de vos appels d’offres.
      </PageText>
    </SocieteContainer>
  );
};

export default Societe;


